export default __webpack_public_path__ + "static/media/remove_card.ac499359.svg";